import React, { useEffect, useRef, useState } from "react";
import styled, { keyframes } from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";

import LSRgH1HeadLine from "../molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import PCContainer from "../atoms/layout/pcContainer";
import LSRgH2HeadLine from "../molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import InputSearch from "../atoms/input/inputSearch";

import { menus } from "../../constant/menu";
import { headerMenuState, headerTriggerState } from "../../store/headerState";
import { route } from "../../router/route";
import { fileUrl } from "../../api/api";
import AuthApi from "../../api/auth.api";

const Header = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const containerRef = useRef(null);

  const headerTriggerStateAtom = useRecoilValue(headerTriggerState);
  const headerMenuStateAtom = useRecoilValue(headerMenuState);

  const menuList = menus;

  const [keyword, setKeyword] = useState("");
  const [isMenuOn, setIsMenuOn] = useState(false);

  const [isLogin, setIsLogin] = useState(false);
  const [name, setName] = useState("");
  const [profile, setProfile] = useState("");

  useEffect(() => {
    const handleClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsMenuOn(false);
      }
    };
    window.addEventListener("mousedown", handleClick);
    return () => window.removeEventListener("mousedown", handleClick);
  }, [containerRef]);

  useEffect(() => {
    let isLogin = sessionStorage.getItem("isLogin");
    let name = sessionStorage.getItem("name");
    let profile = sessionStorage.getItem("profile");

    setIsLogin(isLogin === "true");
    setName(name);
    setProfile(profile);
  }, [pathname, headerTriggerStateAtom]);

  const logoutFunc = async () => {
    try {
      await AuthApi.logout();
    } finally {
      sessionStorage.clear();
      window.location.href = route.login;
    }
  };

  const searchLecture = () => {
    const normalizedKeyword = keyword.trim();
    if (!normalizedKeyword) return;

    navigate(
      `${route.search}?page=1&keyword=${encodeURIComponent(normalizedKeyword)}`,
    );
    setKeyword("");
  };

  return (
    <HeaderSection>
      <HeaderTopWrapper>
        <PCContainer
          style={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <img
            onClick={() => {
              navigate(`${route.home}`);
              setIsMenuOn(false);
            }}
            style={{
              width: 120,
              height: 48,
              cursor: "pointer",
            }}
            src="/assets/icons/logo.png"
            alt="logo"
          />

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            {isLogin ? (
              <div
                onClick={() => {
                  navigate(route.my_page_setting);
                }}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <img
                  style={{
                    width: 22,
                    height: 22,
                    borderRadius: 99,
                    marginRight: 8,
                  }}
                  src={
                    profile && profile !== "null"
                      ? `${fileUrl}/${profile}`
                      : "/assets/icons/profile.png"
                  }
                  alt="profile"
                />
                <LSRgH1HeadLine
                  style={{
                    color: "#6F7480",
                  }}
                >
                  {name}님
                </LSRgH1HeadLine>
              </div>
            ) : (
              <LSRgH1HeadLine
                style={{
                  color: "#6F7480",
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(route.login);
                }}
              >
                로그인
              </LSRgH1HeadLine>
            )}

            <LSRgH1HeadLine
              style={{
                color: "#6F7480",
                cursor: "pointer",
                marginRight: 20,
                marginLeft: 20,
              }}
              onClick={() => {
                if (isLogin) {
                  logoutFunc();
                } else {
                  navigate(route.register);
                }
              }}
            >
              {isLogin ? "로그아웃" : "회원가입"}
            </LSRgH1HeadLine>

            <LSRgH1HeadLine
              style={{
                color: "#6F7480",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(route.customer_service_notice);
              }}
            >
              고객센터
            </LSRgH1HeadLine>
          </div>
        </PCContainer>
      </HeaderTopWrapper>
      <HeaderWrapper>
        <PCContainer
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <img
              onClick={() => {
                setIsMenuOn(!isMenuOn);
              }}
              style={{
                width: 24,
                height: 24,
                cursor: "pointer",
                marginRight: 50,
              }}
              src={
                isMenuOn ? "/assets/icons/menu.png" : "/assets/icons/menu.png"
              }
              alt="menu"
            />

            {menuList.map((item, index) => {
              return (
                <MenuText
                  onClick={() => {
                    navigate(item.src);

                    setIsMenuOn(false);
                  }}
                  key={index}
                  style={{
                    marginRight: menuList.length === index + 1 ? 0 : 42,
                    color:
                      pathname?.includes(item.includeValue) ||
                      (index === 1 &&
                        pathname?.includes(route.lecture_onboarding_complete))
                        ? "#0000c7"
                        : "#101113",
                  }}
                >
                  {item.title}
                </MenuText>
              );
            })}
          </div>
          <div
            style={{
              width: 240,
            }}
          >
            <InputSearch
              placeholder={"강의명"}
              value={keyword}
              onChange={(value) => {
                setKeyword(value);
              }}
              onKeyDown={(e) => {
                // IME 상태 확인
                if (e.key === "Enter" && !e.nativeEvent.isComposing) {
                  searchLecture();
                }
              }}
              onCompositionEnd={(e) => {
                // IME 입력 완료 시 상태 업데이트
                if (e.target.value.trim() !== "") {
                  setKeyword(e.target.value);
                }
              }}
              setDataToKeyword={() => {
                searchLecture();
              }}
            />
          </div>
        </PCContainer>
      </HeaderWrapper>
      {isMenuOn ? (
        <HeaderBottomWrapper ref={containerRef}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              width: 1200,
            }}
          >
            {headerMenuStateAtom.map((item, index) => {
              return item.activation ? (
                <div
                  key={item.id ?? item.title}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginTop: 20,
                    marginRight: 25,
                    minWidth: 146,
                    maxWidth: 146,
                  }}
                >
                  <SubMenuTitleText
                    onClick={() => {
                      if (item.src) {
                        navigate(item.src);
                        setIsMenuOn(false);
                      }
                    }}
                  >
                    {item.title}
                  </SubMenuTitleText>
                  {item.childCategories.map((item02, index) => {
                    return item02.activation ? (
                      <div key={item02.id ?? item02.title}>
                        <SubMenuContentText
                          onClick={() => {
                            if (item02.src) {
                              navigate(item02.src);
                            } else {
                              navigate(
                                `${item.src}?page=1&categoryValue=${item02.id}`,
                              );
                            }

                            setIsMenuOn(false);
                          }}
                          style={{
                            marginBottom:
                              item.childCategories.length === index + 1
                                ? 0
                                : 16,
                          }}
                        >
                          {item02.title}
                        </SubMenuContentText>
                      </div>
                    ) : null;
                  })}
                </div>
              ) : null;
            })}
          </div>
        </HeaderBottomWrapper>
      ) : null}
    </HeaderSection>
  );
};

export default Header;

const HeaderSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  z-index: 10;
`;

const HeaderTopWrapper = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border-bottom: 1px solid #dbdde0;
`;

const HeaderWrapper = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #fff;
`;

const MenuText = styled(LSRgH2HeadLine)`
  cursor: pointer;

  color: #101113;

  &:hover {
    color: #0000c7 !important;
  }
`;

// 아래로 펼쳐지는 애니메이션 정의
const slideDown = keyframes`
  from {
    max-height: 0;
    opacity: 0;
  }
  to {
    max-height: 500px; /* 예상 최대 높이 설정 */
    opacity: 1;
  }
`;

const HeaderBottomWrapper = styled.div`
  width: 100%;

  overflow: hidden;
  animation: ${slideDown} 0.5s ease-out forwards;
  transition: max-height 0.5s ease-out;

  display: flex;
  flex-direction: row;
  justify-content: center;

  background-color: #ffffff;
  position: absolute;
  top: 160px;
  padding: 0px 0px 56px 0px;
  z-index: 20;
  overflow-x: auto;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #dcdcdc;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 2550, 255, 0.1); /*스크롤바 뒷 배경 색상*/
    border-radius: 10px;
    box-shadow: inset 0px 0px 5px white;
  }
`;

const SubMenuTitleText = styled(LSRgH2HeadLine)`
  cursor: pointer;
  font-size: 18px;
  color: #000000;
  font-weight: 700;
  margin-bottom: 16px;
  &:hover {
    color: #0000c7;
  }
`;

const SubMenuContentText = styled(LSRgH2HeadLine)`
  cursor: pointer;
  color: #000000;
  font-weight: 400;

  &:hover {
    color: #0000c7;
  }
`;
